import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import { useThemeMode } from '../context/ThemeContext';

function ThemePreferenceSelector() {
    const { preference, setPreference } = useThemeMode();

    const handleChange = (event, value) => {
        if (value !== null) {
            setPreference(value);
        }
    };

    return (
        <ToggleButtonGroup
            value={preference}
            exclusive
            onChange={handleChange}
            aria-label="Theme preference"
            size="small"
        >
            <ToggleButton value="light" aria-label="Light theme">
                <LightModeOutlinedIcon sx={{ mr: 0.75, fontSize: 18 }} />
                Light
            </ToggleButton>
            <ToggleButton value="system" aria-label="Follow system theme">
                <SettingsBrightnessOutlinedIcon sx={{ mr: 0.75, fontSize: 18 }} />
                System
            </ToggleButton>
            <ToggleButton value="dark" aria-label="Dark theme">
                <DarkModeOutlinedIcon sx={{ mr: 0.75, fontSize: 18 }} />
                Dark
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

export default ThemePreferenceSelector;
